import { Dialog, Paper, styled, TableCell, TableRow, TextField } from '@mui/material'

interface ColorProps {
    color: string
}

interface SortIconContainerProps {
    reversed: boolean
    hidden: boolean
}

export const HeaderCell = styled(TableCell)`
    font-style: normal;
    font-weight: 400;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: #54687d;
`

export const Cell = styled(TableCell)`
    border-bottom: none;
`

export const LevelCell = styled('div')`
    border-bottom: none;
    display: flex;
    align-items: center;
    gap: 8px;
`

export const Row = styled(TableRow)`
    &:nth-of-type(2n) {
        background: #f7f8f9;
    }
`

export const HeaderItemContent = styled('div')`
    display: flex;
    align-items: center;
    cursor: pointer;
`

export const Skill = styled('div')`
    display: flex;
    align-items: center;
`

export const SkillColor = styled('div')<ColorProps>`
    width: 7px;
    height: 7px;
    border-radius: 7px;
    margin-right: 6px;
    background: ${({ color }) => color};
`

export const SkillName = styled('span')`
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #173348;
`

export const Skills = styled('div')`
    display: flex;
    overflow: hidden;
    gap: 6px;
`

export const SortIconContainer = styled('div')<SortIconContainerProps>`
    display: flex;
    align-items: center;

    > svg {
        ${({ reversed }) => reversed && `transform: rotate(180deg);`}
        ${({ hidden }) => `visibility: ${hidden ? 'hidden' : 'visible;'}`}
    }
`

export const NameBlock = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
`

export const PositionBlock = styled('div')`
    color: #95a5b6;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.24px;
`

export const EmployeeName = styled('div')`
    display: flex;
    gap: 12px;
`

export const Icons = styled('div')`
    display: flex;
    align-items: center;
    gap: 20px;
`

export const StatusWrapper = styled('div')`
    display: flex;
    width: 100%;
    padding: 24px 40px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    border-bottom: 1px solid #c6ced8;
    border-top: 1px solid #c6ced8;

    background: #f7f8f9;
`

export const SelectedItems = styled('div')`
    color: #60758c;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 114.286% */
`
export const StatusButtons = styled('div')`
    display: flex;
    align-items: center;
    gap: 20px;
`

export const SPaper = styled(Paper)`
    display: flex;
    /* width: 363px; */
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    border-radius: 5px;
    border: 1px solid #dee3e9;
    background: #f7f8f9;

    /* dialog-shadow */
    box-shadow: 2px 4px 10px 0px rgba(0, 0, 0, 0.15);

    box-sizing: border-box;
`

export const SPaperLarge = styled(Paper)`
    display: flex;
    width: 407px !important;
    /* height: 218px; */
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 22px;

    border-radius: 5px;
    border: 1px solid #dee3e9;
    background: #f7f8f9;

    /* dialog-shadow */
    box-shadow: 2px 4px 10px 0px rgba(0, 0, 0, 0.15);

    box-sizing: border-box;
`

export const SHeader = styled('div')`
    color: #173348;

    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 111.111% */

    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 24px;
    cursor: move !important;
`

export const SContent = styled('div')`
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */

    display: flex;
    /* height: 65px; */
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
`

export const SDialog = styled(Dialog)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
`

export const CommentInfo = styled('div')`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
`

export const Author = styled('div')`
    display: flex;
    gap: 8px;
    align-items: center;
`

export const Date = styled('div')`
    display: flex;
    align-items: center;

    color: #54687d;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    margin-right: 8px;
`

export const STextField = styled(TextField)`
    box-sizing: border-box;

    font-size: 14px !important;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    padding-top: 0px;
`
